// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2wI-I","colBig":"styles_colBig__IAALo","colSmall":"styles_colSmall__3f87h"};